<template>
	<div style='text-align: center;'>

		<div class="headbox">
			<div style='background: #000000ba;    height: 600px;'>

				<el-menu mode="horizontal" background-color="#303133" text-color="#fff" active-text-color="#ffaa00">
					<el-menu-item index="1">
						<span style="font-size: 28px; font-weight: bold;">穹天信息</span>
					</el-menu-item>
					<el-menu-item index="0" style="float: right;"><a href="tel:+8618661695165">18661695165</a></el-menu-item>
					<el-menu-item index="2" style="float: right;">ERP</el-menu-item>
					<el-menu-item index="3" style="float: right;">MES</el-menu-item>
					<el-menu-item index="4" style="float: right;">WMS</el-menu-item>
					<el-menu-item index="5" style="float: right;">OA</el-menu-item>
					<el-menu-item index="6" style="float: right;">SCM</el-menu-item>
				</el-menu>

				<div style="color:#409eff">

					<h1 style="font-size: 108px;" class="animate__animated  animate__bounce">企业综智平台</h1>
					<h3>企业 信息化系统改造升级|</h3>
					<h2 class="animate__animated animate__lightSpeedInLeft">我们只做好用，易用的企业管理系统，定制企业专属的自有管理系统.</h2>
					<el-button type="danger">快来加入综智平台</el-button>
				</div>
			</div>
		</div>

		<div style="color:#409eff; margin: 0;padding: 1px;">

			<h1 style="font-size: 38px;">综智平台提供卓越的服务</h1>
			<h3>企业服务类目</h3>

			<div style="display: flex;padding: 18px;justify-content: space-around;">
				<el-card class="box-card">
					<div slot="header" class="clearfix">
						<span>企业系统定制</span>
					</div>
					<div>

						<p>
							定制系统，驱动企业进化
							一企一系统，精准匹配业务
							不将就，只定制
						</p>
					</div>
				</el-card>

				<el-card class="box-card">
					<div slot="header" class="clearfix">
						<span>报表分析定制</span>
					</div>
					<div>
						<p>
							已为 50+ 企业构建专属分析平台，平均减少人工报表工时 80%
						</p>
					</div>
				</el-card>

				<el-card class="box-card">
					<div slot="header" class="clearfix">
						<span>完全自主开发</span>
					</div>
					<div>
						<p>
							自主开发，安心托付
							代码自有，系统无忧
							不拼凑，只原创 —— 专属报表系统 </p>
					</div>
				</el-card>

				<el-card class="box-card">
					<div slot="header" class="clearfix">
						<span>不限使用人数</span>
					</div>
					<div>
						<p>
							不限人数，不限账号，只限想象力
							一人用是工具，全员用是引擎
							告别人头费，拥抱真数字化
						</p>
					</div>
				</el-card>
			</div>
		</div>

		<div style="color:#409eff; margin: 0;padding: 1px; height: 600px;">

			<h1 style="font-size: 38px;">客户案例</h1>
			<!-- <h3>感谢每一位</h3> -->

			<div style="display: flex;padding: 18px;justify-content: space-around;">
				<el-card class="box-card">

					<div>
						<div style="display: flex;    align-items: center;">
							<el-image style="width: 60px; height: 60px" src="../assets/heico.png"
								fit="fit"></el-image>
							<div style="padding: 0 16px;">

								<span style="font-size: 22px;margin-top: -18px;"> 美国-海高集团</span><br>
								<span style="font-size: 12px;margin-top: -18px;"> 全链路,多公司报表统计</span>
							</div>
						</div>
						<p>
							全球业务链,年订单额高达1亿美元,约9亿人民币左右.
						<ul>
							<li>上海 公司</li>
							<li>东欧 公司</li>
							<li>印度 公司</li>
							<li>墨西哥 公司</li>
						</ul>
						</p>
					</div>
				</el-card>

				<el-card class="box-card">

					<div>
						<div style="display: flex;    align-items: center;">
							<el-image style="width: 60px; height: 60px" src="../src/assets/huicheng.jpg"
								fit="fit"></el-image>
							<div style="padding: 0 16px;">

								<span style="font-size: 22px;margin-top: -18px;"> 青岛-汇成工业</span><br>
								<span style="font-size: 12px;margin-top: -18px;"> 小批量多品种</span>
							</div>
						</div>
						<p>
							金属加工行业,小批量多品种,企业快速反应,进销存加生产管理.
							<ul>
								<li>日订单达90+</li>
								<li>原材料按需采购</li>
								<li>订单按项目归集</li>
								<li>灵活定义产品BOM</li>
							</ul>
						</p>
					</div>
				</el-card>

				<el-card class="box-card">

					<div>
						<div style="display: flex;    align-items: center;">
							<el-image style="width: 60px; height: 60px" src="../assets/sail-industry.jpg"
								fit="fit"></el-image>
							<div style="padding: 0 16px;">

								<span style="font-size: 22px;margin-top: -18px;"> 泰国-Sail</span><br>
								<span style="font-size: 12px;margin-top: -18px;"> 标准工厂</span>
							</div>
						</div>
						<p>
							全球业务链,年订单额高达1亿美元,约9亿人民币左右.
							<ul>
								<li>日出入库达300次</li>
								<li>多仓库管理</li>
								<li>中泰公司协同</li>
								<li>原料批次追溯</li>
							</ul>
						</p>
					</div>
				</el-card>
				<el-card class="box-card">

					<div>
						<div style="display: flex;    align-items: center;">
							<el-image style="width: 60px; height: 60px" src="/src/assets/xinglianke.png"
								fit="fit"></el-image>
							<div style="padding: 0 16px;">

								<span style="font-size: 22px;margin-top: -18px;"> 昆山-星联科</span><br>
								<span style="font-size: 12px;margin-top: -18px;"> 大件小批量</span>
							</div>
						</div>
						<p>
							专注于为全球客户提供高精度、定制化的大件金属结构件加工服务.
							<ul>
								<li>支持非标定制、试产、打样</li>
								<li>提供成本可控、交付稳定的加工</li>
								<li>建立完整的物料来源追踪体系</li>
								<li>可对接客户系统，数据透明化</li>
							</ul>
						</p>
					</div>
				</el-card>
			</div>
		</div>
		<div style="color: #b6b6b6; margin: 0;padding: 1px;">

			<span>青岛穹天 © CopyRights 2022 All Rights Reserved 备案号：鲁ICP备2022027474号-1</span>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'IndexPage',
		props: {}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.headbox {
		background-image: url('../assets/indexbg.jpg');
		background-size: cover;
	}

	.el-card {
		margin: 18px;
		text-align: left;
	}
</style>